<div class="menu-scroll-content">
  <ul app-barra-lateral-submenu [item]="model" root="true" class="navigation-menu" visible="true" parentActive="true"></ul>
</div>
